import { NgModule } from '@angular/core';

import { ObrigacoesComponent } from './obrigacoes.component';
import { SharedModule } from "../../shared/shared.module";
import { ObrigacaoApiService } from "./shared/obrigacao-api.service";
import { ObrigacaoNavigationService } from "./shared/obrigacao-navigation.service";
import { Obrigacoeservice } from "./shared/obrigacao.service";
import { ObrigacaoFormComponent } from "./obrigacao-form/obrigacao-form.component";
import { ObrigacaoListComponent } from "./obrigacao-list/obrigacao-list.component";
import { ObrigacoesRoutingModule } from "./obrigacoes-routing.module";
import { ObrigacaoTipoFormComponent } from "./obrigacao-tipos/obrigacao-tipo-form/obrigacao-tipo-form.component";
import { ObrigacaoTipoListComponent } from "./obrigacao-tipos/obrigacao-tipo-list/obrigacao-tipo-list.component";
import { ObrigacaoTipoApiService } from "./obrigacao-tipos/shared/obrigacao-tipo-api.service";
import { ObrigacaoTipoNavigationService } from "./obrigacao-tipos/shared/obrigacao-tipo-navigation.service";
import { ObrigacaoTipoService } from "./obrigacao-tipos/shared/obrigacao-tipo.service";

@NgModule({
    imports: [
        SharedModule,
        ObrigacoesRoutingModule
    ],
    providers: [
        ObrigacaoApiService,
        ObrigacaoNavigationService,
        Obrigacoeservice,
        ObrigacaoTipoApiService,
        ObrigacaoTipoNavigationService,
        ObrigacaoTipoService
    ],
    declarations: [
        ObrigacoesComponent,
        ObrigacaoFormComponent,
        ObrigacaoListComponent,
        ObrigacaoTipoFormComponent,
        ObrigacaoTipoListComponent
    ]
})
export class ObrigacoesModule { }



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/despachos/obrigacoes/obrigacoes.module.ts
 **/